import { Map } from "immutable";

const Feedback = (feedback) => {
	let feedbackMap = Map();

	const defaultState = Map({
		allowNotes: false,
		allowNotesManager: false,
		allowRecognition: false,
		allowSubject: false,
		allowSubjectManager: false,
		allowRequestFeedback: false,
		_hasSlideout: false,
		_onlyNotes: false,
	});

	try {
		feedbackMap = defaultState.withMutations((nest) => {
			defaultState.keySeq().forEach((key) => {
				if (Object.prototype.hasOwnProperty.call(feedback, key)) {
					nest.set(key, feedback[key]);
				}
			});
		});

		const trueList = [];

		// count the number of true values
		feedbackMap.forEach((value, key) => {
			if (value === true) {
				trueList.push(key);
			}
		});

		// set if only notes
		feedbackMap = feedbackMap.set("_onlyNotes", true);

		trueList.forEach((item) => {
			if (item !== "allowNotes" && item !== "allowNotesManager") {
				feedbackMap = feedbackMap.set("_onlyNotes", false);
			}
		});

		feedbackMap = feedbackMap.set("_hasSlideout", trueList.length !== 0);
	} catch (err) {
		feedbackMap = defaultState;
	}

	return feedbackMap;
};

export default Feedback;
